export default __webpack_public_path__ + "locales/el-GR/FilesSettings.json?hash=a2a4e79d0540c2f72cca0bcc8db92533";